module.exports = {
  api_endpoint: process.env.VUE_APP_API_ENDPOINT
    ? process.env.VUE_APP_API_ENDPOINT
    : "http://localhost:8080",
  title: "Vikingo dashboard",
  description: "Vikingo - security platform",
};
